import React, { Fragment } from 'react';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.png'
// import Privci1 from '../../images/about/about-1/2.jpg'
import Privci2 from '../../images/about/about-1/1.jpg'
import Privci3 from '../../images/about/about-1/2.jpg'
import FAQAccordion from '../../components/FaqSection/FAQAccordion';



const PrivacyPage = () => {
    return (
        <Fragment>
            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle pageTitle={''} pagesub={'Privacy Policy'} />
            <ScrollTextAnimation />
            <section className="pf-terms-section section-padding pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pf-terms-wrap">
                                {/* <div className="pf-terms-img">
                                    <img src={Privci1} alt="" />
                                </div> */}
                                <div className="pf-terms-text">

                                    <h2>Why Our Privacy Policy Matters</h2>

                                    <p>
                                        At Luxrock Realty, we value the trust you place in us while searching,
                                        buying or selling property. Our Privacy Policy explains how we collect,
                                        use and protect your personal information when you interact with our
                                        website or our real estate consultants. This helps ensure transparency,
                                        security and a safe property transaction experience.
                                    </p>

                                    <p>
                                        When you submit your details for property inquiries, site visits,
                                        investment consultation or selling assistance, the information is used
                                        only to provide relevant property options, professional advice and
                                        transaction support. We never misuse or sell your personal data to
                                        unauthorized third parties.
                                    </p>

                                    <ul>
                                        <li>Use of website for property inquiries and consultations only.</li>
                                        <li>Submission of correct contact details for communication.</li>
                                        <li>Protection of customer information and confidentiality.</li>
                                        <li>Verification of property listings before sharing with clients.</li>
                                        <li>Transparent transactions and documentation assistance.</li>
                                    </ul>

                                    <p>
                                        Property prices, availability and investment returns mentioned on the
                                        website are indicative and may change depending on market conditions,
                                        developer updates or government regulations. Our team always confirms
                                        final details before proceeding with any booking or agreement.
                                    </p>

                                    <div className="row t-sub">
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="pf-p-details-img">
                                                <img src={Privci2} alt="Property Consultation" />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-12">
                                            <div className="pf-p-details-img">
                                                <img src={Privci3} alt="Property Documentation" />
                                            </div>
                                        </div>
                                    </div>

                                    <p>
                                        Luxrock Realty assists clients with property visits, negotiations,
                                        legal documentation and registration support. However, final decisions
                                        remain the responsibility of the buyer or seller after reviewing all
                                        documents and legal approvals. We recommend consulting financial and
                                        legal advisors before completing high-value transactions.
                                    </p>

                                </div>

                                <div className="pf-faq-section">
                                    <h4>Frequently Ask Questions</h4>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <FAQAccordion />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PrivacyPage;





